import script from "./Buscador.vue?vue&type=script&setup=true&lang=js"
export * from "./Buscador.vue?vue&type=script&setup=true&lang=js"

import "./Buscador.vue?vue&type=style&index=0&id=d8536cfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8536cfc"]])

export default __exports__